import useUserContext from 'Context/UserContext';
import useHomeContext from 'Context/HomeContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';

const User = () => {
  const { updateUserResource } = useUserContext();
  const { refreshHomeResource } = useHomeContext();

  useComponentDidMount(async () => {
    const home = await refreshHomeResource();
    const [userResource] = await home.relationship(fr.relationships.user.name).link('related').get();
    updateUserResource(userResource);
    navigateTo('/');
    // TODO: we want to use the user resource from the auth flow
  });

  return null;
};

export default User;
